import { Button } from '@osmosis/react-ui/components/Button';
import { FormattedMessage } from 'react-intl';

interface Props {
  isShow: boolean;
  onReset: () => void;
}

/**
 * SentenceDnDResetButton.
 */
export const SentenceDnDResetButton = ({ isShow, onReset }: Props) => {
  if (!isShow) {
    return null;
  }

  return (
    <Button
      mt={3}
      onClick={onReset}
      width="max-content"
      variant="transparent"
      color="primary"
    >
      <FormattedMessage
        id="quiz.sentence-drag-and-drop.reset"
        defaultMessage="Reset"
      />
    </Button>
  );
};
